import { render, staticRenderFns } from "./VistaFacturas.vue?vue&type=template&id=b69c1166&"
import script from "./VistaFacturas.vue?vue&type=script&lang=js&"
export * from "./VistaFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
